import './ConfirmButton.scss'

import React, {Component} from 'react';
import { Button } from 'react-bootstrap'

class ConfirmButton extends Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.submit = this.submit.bind(this)
  }

  submit() {
    const isSuccess = this.props.onSubmit()
    if(isSuccess) {
      this.setState({pending: true})
      setTimeout(()=>{
        this.setState({
          pending: false,
          complete: true
        })
        setTimeout(this.props.onFinish, this.props.timeouts)
      }, this.props.timeouts)
    }
  }

  render() {
    return (
      <div className="ConfirmButton">
      { this.state.pending ? <div className="ConfirmButton__loading"><i className="fa fa-circle-o-notch rotating" aria-hidden="true"></i> {this.props.pendingText}</div> : null }
      { this.state.complete ? <div className="ConfirmButton__sent"><i className="fa fa-check" aria-hidden="true"></i> {this.props.completeText}</div> : null }
      { (!this.state.pending && !this.state.complete) ? <Button bsStyle="success" className="pull-left" onClick={this.submit}>{this.props.initialText}</Button> : null }
      </div>
    )
  }
}

export default ConfirmButton
